import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import MainDrawerPage from "./components/drawer";
import Dashboard from "./components/Dashboard";
import LoginService from "./services/LoginService";
import cookies from "./utils/cookies";

const App = () => {
  useEffect(() => {
    const url = new URL(window.location.href);

    url.searchParams.forEach((v, k) => {
      if (k === "access_token") {
        const expires = new Date(
          JSON.parse(Buffer.from(v.split(".")[1], "base64").toString("ascii"))
            .exp * 1000
        );
        cookies.set("access_token", v, expires);
      } else if (k === "mode") {
        localStorage.setItem("mode", v);
      } else if (k === "app") {
        localStorage.setItem("app", v);
      }
    });

    const hostname = url.hostname.split(".");
    if (hostname.length > 1) {
      localStorage.setItem("app", hostname[0]);
    }

    const accessToken = cookies.get("access_token");

    if (
      !accessToken &&
      (localStorage.getItem("mode") ?? "visitor") === "logged"
    ) {
      return LoginService.login();
    }

    if (url.searchParams.size > 0) {
      return window.location.assign("/");
    }
  }, []);

  return (
    <Router>
      <Switch>
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/" component={MainDrawerPage} />
      </Switch>
    </Router>
  );
};

export default App;
